module.exports = __webpack_public_path__ + "img/费用处理.de28baad.svg";